import { render, staticRenderFns } from "./DocsAttach.vue?vue&type=template&id=1c4ff8de&scoped=true"
import script from "./DocsAttach.vue?vue&type=script&lang=ts"
export * from "./DocsAttach.vue?vue&type=script&lang=ts"
import style0 from "./DocsAttach.vue?vue&type=style&index=0&id=1c4ff8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ff8de",
  null
  
)

export default component.exports